export const svgId = 'subject-visual-component-svg';
